import { Grid, Typography } from '@mui/material';
import React from 'react';
import { ToggleButtonItem, WO2ToggleButtonGroup } from 'src/common';
import { FeesType, ImputationType, SecurityExclusionType } from '../store/types';

const feesButtons: ToggleButtonItem<FeesType>[] = [
  { name: 'Before Fees', value: FeesType.BeforeFees },
  { name: 'After Fees', value: FeesType.AfterFees },
];

const imputationButtons: ToggleButtonItem<ImputationType>[] = [
  { name: 'Before Franking', value: ImputationType.BeforeFranking },
  { name: 'After Franking', value: ImputationType.AfterFranking },
];

interface Props {
  setFeesTypeParameter: (type: FeesType) => void;
  setImputationTypeParameter: (type: ImputationType) => void;
  setSecurityExclusionTypeParameter: (type: SecurityExclusionType) => void;
  feesType: FeesType;
  imputationType: ImputationType;
  securityExclusionType: SecurityExclusionType;
  applyExclusionDisabled: boolean;
}

export const PerformanceToggles = ({
  setFeesTypeParameter,
  setImputationTypeParameter,
  setSecurityExclusionTypeParameter,
  feesType,
  imputationType,
  securityExclusionType,
  applyExclusionDisabled,
}: Props) => {
  const securityExclusionButtons: ToggleButtonItem<SecurityExclusionType>[] = [
    { name: 'Include All', value: SecurityExclusionType.IncludeAllSecurities },
    { name: 'Apply Exclusions', value: SecurityExclusionType.ApplyExclusionList, disabled: applyExclusionDisabled },
  ];

  const handleFeesTypeChange = (type: FeesType) => {
    setFeesTypeParameter(type);
  };

  const handleImputationTypeChange = (type: ImputationType) => {
    setImputationTypeParameter(type);
  };

  const handleSecurityExclusionTypeChange = (type: SecurityExclusionType) => {
    setSecurityExclusionTypeParameter(type);
  };

  return (
    <Grid item container xs={12} sm={2} spacing={2} direction="column">
      <Grid item container direction="column" alignItems="flex-start" spacing={1}>
        <Grid item>
          <Typography variant="h4">Securities</Typography>
        </Grid>
        <Grid item sx={{ width: '100%' }}>
          <WO2ToggleButtonGroup
            fullWidth
            buttons={securityExclusionButtons}
            value={securityExclusionType}
            onChangeHandler={handleSecurityExclusionTypeChange}
          />
        </Grid>
      </Grid>
      <Grid item container direction="column" alignItems="flex-start" spacing={1}>
        <Grid item>
          <Typography variant="h4">Fees</Typography>
        </Grid>
        <Grid item sx={{ width: '100%' }}>
          <WO2ToggleButtonGroup fullWidth buttons={feesButtons} value={feesType} onChangeHandler={handleFeesTypeChange} />
        </Grid>
      </Grid>
      <Grid item container direction="column" alignItems="flex-start" spacing={1}>
        <Grid item>
          <Typography variant="h4">Imputation</Typography>
        </Grid>
        <Grid item sx={{ width: '100%' }}>
          <WO2ToggleButtonGroup fullWidth buttons={imputationButtons} value={imputationType} onChangeHandler={handleImputationTypeChange} />
        </Grid>
      </Grid>
    </Grid>
  );
};
